import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { getValueAtPath } from '@/lib/utils';
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";


export const PhoneNumberInput = ({ id, form, isRequired, className, label }) => {
    const hasError = getValueAtPath(form.touched, id) && getValueAtPath(form.errors, id);
    const inputClass = `form-control${hasError ? ' is-invalid' : ''}${className ? ` ${className}` : ''}`;
    const value = getValueAtPath(form.values, id);
    const [country, setCountry] = useState("AU");

    const handleChange = useCallback((value) => {
        const parsed = value ? parsePhoneNumber(value) : "";
        if (parsed) {
            value = parsed.number;
            if (!parsed.isValid()) {
                form.setFieldError(id, "Invalid phone number");
            }
        } else {
            form.setFieldError(id, "Invalid phone number");
        }
        form.setFieldTouched(id, true, true);
        form.setFieldValue(id, value, true);
    }, [form, id]);

    return (
        <>
            {label && (
                <label>{label} {isRequired && <sup className="required">*</sup>}</label>
            )}
            <div className="phone-input-wrapper form-control p-0 m-0">
                <PhoneInput
                    id={id}
                    className={inputClass}
                    international
                    defaultCountry={country}
                    countryCallingCodeEditable={false}
                    onCountryChange={setCountry}
                    value={value}
                    onChange={handleChange}
                    onBlur={form.handleBlur}
                />
            </div>
            {hasError && (
                <div id={`${id}Feedback`} className="invalid-feedback d-block">
                    {getValueAtPath(form.errors, id)}
                </div>
            )}
        </>
    );
}
PhoneNumberInput.propTypes = {
    id: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    isRequired: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string
};

PhoneNumberInput.defaultProps = {
    isRequired: false,
    className: '',
    label: ''
};